// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Raleway';
  overflow-x: hidden;
  width: 100%;

}

/* NAV BAR */

.navbar-header h1 {
  font-weight: 300;
  color: black;
  letter-spacing: 3px;
  display: flex;
}

.navbar-header {
  display: flex;
  flex-direction: row;
  overflow-y: hidden;
}

nav.navbar a.navbar-brand {
  width: 45%;
}

.navbar-links {
  align-items: center !important;
  display: inline-block;
  vertical-align: middle;
}

.navbar-links .navbar-link {
  color: #808080;
  align-items: center !important;
  display: inline-block;
  vertical-align: middle;
  width: 33%;
  text-align: center;
}

.navbar-links .navbar-link:hover {
  color: rgb(70, 69, 69);
  font-weight: 550;
}

.navbar-links .navbar-nav {
  align-items: center !important;
  display: inline;
  vertical-align: middle;
  padding-right: 10%;
}

.Nav-bar-general {
  align-items: center;
  line-height: 3.5;
  display: inline-block;
  vertical-align: middle;
  color: #808080;
  padding-left: 3.5%;
}

.Nav-bar-general .logo {
  height: 15vmin;
  width: 15vmin;
  pointer-events: none;
}


@media screen and (max-width: 1165px) {
  .navbar-header h1 {
    display: inline;
    padding-top: 0%;
  }

  .navbar-links {
    display: inline;
    padding-top: 0%;
  }

  .navbar-links .navbar-link {
    width: 33%;
    padding-top: 0%;
  }

  .Nav-bar-general {
    display: inline;
    padding-top: 0%;
  }

  nav.navbar a.navbar-brand {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .navbar-links .navbar-link {
    display: block;
    flex-direction: column;
    vertical-align: middle;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex: none;
    width: 100%;
  }
}

/* BANNER */

hr.solid {
  border-top: 5px solid #808080;
  padding: 0;
  padding-bottom: 1%;
  overflow-y: hidden;
}

.banner {
  align-items: center;
  display: inline-block;
  vertical-align: middle;
  overflow-y: hidden;

  text-decoration: none !important;

  .section-container {
    overflow-y: hidden;
    padding: 0.8%;
    position: relative;
    text-align: center;
    color: white;
    padding-left: 8%;
    padding-right: 8%;
    text-decoration: none;
    color: black;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;

    img {
      padding-left: 3%;
      padding-right: 3%;
      z-index: 0;
    }

    a {
      text-decoration: none !important;
    }

    p {
      margin-top: 2%;
      font-size: 1.5em;
      font-weight: 200;
      text-decoration: none;
      color: black;
    }

    .individualSection:hover p {
      font-weight: 300;
    }

    .individualSection:hover img {
      filter: brightness(80%)
    }

  }

  @media screen and (max-width: 1500px) {
    .section-container {
      p {
        font-size: 15px;
      }
    }
  }

  @media screen and (max-width: 1050px) {
    .section-container {
      display: grid;
      grid-template-columns: 1fr 1fr;

      p {
        font-size: 15px;
      }
    }
  }

  @media screen and (max-width: 480px) {
    .section-container {
      display: grid;
      grid-template-columns: 1fr;

      p {
        font-size: 15px;
      }
    }
  }
}





.testBanner {
  align-items: center;
  display: inline-block;
  vertical-align: middle;
  overflow-y: hidden;
  text-decoration: none !important;

  .section-container {
    overflow-y: hidden;
    padding: 0.8%;
    position: relative;
    text-align: center;
    color: white;
    padding-left: 8%;
    padding-right: 8%;
    text-decoration: none;
    color: black;
    display: grid;

    img {
      padding-left: 3%;
      padding-right: 3%;
      z-index: 0;
      overflow-y: hidden;
    }

    a {
      text-decoration: none !important;
    }

    p {
      margin-top: 2%;
      font-size: 1.5em;
      font-weight: 200;
      text-decoration: none;
      color: black;
    }

    .individualSection:hover p {
      font-weight: 300;
      overflow-y: hidden;

    }

    .individualSection:hover img {
      filter: brightness(80%);
      overflow-y: hidden;

    }

  }

  .section-carrusel {
    overflow-y: hidden;
    padding: 0.8%;
    position: relative;
    text-align: center;
    color: white;
    padding-left: 8%;
    padding-right: 8%;
    text-decoration: none;
    color: black;
    display: grid;

    img {
      padding-left: 3%;
      padding-right: 3%;
      z-index: 0;
      overflow-y: hidden;

    }

    a {
      text-decoration: none !important;
    }

    p {
      margin-top: 2%;
      font-size: 1.5em;
      font-weight: 200;
      text-decoration: none;
      color: black;
    }

    .individualSection {
      overflow: hidden;
      overflow-y: hidden;
      position: relative;
      z-index: 9;
    }

    .individualSection:hover {
      overflow: hidden;
      overflow-y: hidden;

      p {
        font-weight: 300;
      }

      img {
        filter: brightness(80%)
      }
    }


  }

  @media screen and (max-width: 1500px) {
    .section-carrusel {
      p {
        font-size: 15px;
      }
    }
  }

  @media screen and (max-width: 1050px) {
    .section-carrusel {
      display: grid;

      p {
        font-size: 15px;
      }
    }
  }

  @media screen and (max-width: 480px) {
    .section-carrusel {
      display: grid;

      p {
        font-size: 15px;
      }
    }
  }
}













/* CAROUSEL */

.react-multi-carousel-list {
  width: auto;
}

.react-multi-carousel-track {
  width: auto;
}

.react-multiple-carousel__arrow {
  width: auto;
  margin: -4%;
  overflow: visible;
  z-index: 10000000000 !important;
  position: absolute;
}

.react-multi-carousel {
  position: relative;
}






/* SECTIONS*/
.sections {

  h2 {
    padding-top: 1%;
    padding-bottom: 2%;
    font-weight: 200;
  }

  img {
    padding: 10px 10px 10px 10px;
    object-fit: cover;
  }

  .clickableImg:hover {
    filter: brightness(85%)
  }

  p {
    font-size: 1.1em;
    margin-top: 1%;
    margin-bottom: 1%;
    letter-spacing: 0.8px;
    line-height: 1.5em;
    width: 96%;
    text-align: justify;
    text-justify: inter-word;
    padding-left: 10%;
    padding-right: 10%;
  }

  .genericSection {
    padding-left: 10%;
    padding-right: 10%;

    .secondRow {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }

    .section-nav {
      padding: 0.8%;
      padding-top: 2%;
      position: relative;
      text-align: center;
      text-decoration: none;
      color: black;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;

      p {
        a {
          text-decoration: none !important;
          font-size: 1.5em;
          font-weight: 200;
          text-decoration: none;
          color: grey;
        }

        a:hover {
          color: rgb(70, 69, 69);
          font-weight: 400;
        }

        .ilu {
          font-weight: 600;
          color: black;
        }
      }

    }

  }

  .illustration {
    padding-left: 10%;
    padding-right: 10%;

    .section-nav {
      padding: 0.8%;
      padding-top: 2%;
      position: relative;
      text-align: center;
      text-decoration: none;
      color: black;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;

      p {
        a {
          text-decoration: none !important;
          font-size: 1.5em;
          font-weight: 200;
          text-decoration: none;
          color: grey;
        }

        a:hover {
          color: rgb(70, 69, 69);
          font-weight: 400;
        }

        .ilu {
          font-weight: 600;
          color: black;
        }
      }

    }

    .firstRow {
      display: grid;
      grid-template-columns: 1fr 1fr;

      .fourImages {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
    }

    .secondRow {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }

    @media screen and (max-width: 480px) {
      .secondRow {
        display: grid;
        grid-template-columns: 1fr;
      }
    }
  }

  .sketchbook {
    padding-left: 10%;
    padding-right: 10%;

    .section-nav {
      padding: 0.8%;
      padding-top: 2%;
      position: relative;
      text-align: center;
      text-decoration: none;
      color: black;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;

      p {
        a {
          text-decoration: none !important;
          font-size: 1.5em;
          font-weight: 200;
          text-decoration: none;
          color: grey;
        }

        a:hover {
          color: rgb(70, 69, 69);
          font-weight: 400;
        }

        .ske {
          font-weight: 600;
          color: black;
        }
      }
    }

    .threeRows {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }

    @media screen and (max-width: 480px) {
      .threeRows {
        display: grid;
        grid-template-columns: 1fr;
      }
    }
  }

  .CharacterDesign {
    padding-left: 10%;
    padding-right: 10%;

    .section-nav {
      padding: 0.8%;
      padding-top: 2%;
      position: relative;
      text-align: center;
      text-decoration: none;
      color: black;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;

      p {
        a {
          text-decoration: none !important;
          font-size: 1.45em;
          font-weight: 200;
          text-decoration: none;
          color: grey;
        }

        a:hover {
          color: rgb(70, 69, 69);
          font-weight: 400;
        }

        .cd {
          font-weight: 600;
          color: black;
        }
      }
    }

    .chaD {
      font-weight: 350;
    }

    .chaD:hover {
      font-weight: 400;
    }

    .creD:hover {
      font-weight: 400;
    }

    .creD2 {
      font-weight: 350;
    }

    .chaD2:hover {
      font-weight: 400;
    }

    .creD2:hover {
      font-weight: 400;
    }

    .secondTitle {
      padding: 4%;

    }

    a {
      text-decoration: none;
      color: black;
    }

    hr.solid {
      border-top: 5px solid #808080;
      padding-top: 2%;
      padding-bottom: 2%;
    }
  }



  .CreatureDesign {
    padding-left: 10%;
    padding-right: 10%;


  }

  .PropDesign {
    padding-left: 10%;
    padding-right: 10%;

    .section-nav {
      padding: 0.8%;
      position: relative;
      text-align: center;
      text-decoration: none;
      color: black;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;

      p {
        a {
          text-decoration: none !important;
          font-size: 1.5em;
          font-weight: 200;
          text-decoration: none;
          color: grey;
        }

        a:hover {
          color: rgb(70, 69, 69);
          font-weight: 400;
        }

        .pd {
          font-weight: 600;
          color: black;
        }
      }
    }

    .threeRows {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }

    @media screen and (max-width: 480px) {
      .threeRows {
        display: grid;
        grid-template-columns: 1fr;
      }
    }
  }

  .NDA {
    padding-left: 10%;
    padding-right: 10%;

    .twoImages {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

  }
}


/* FOOTER */

.footer {
  width: 100%;

  .section-nav {
    padding: 0.8%;
    position: relative;
    text-align: center;
    text-decoration: none;
    color: black;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;

    p {
      a {
        text-decoration: none !important;
        font-size: 1.5em;
        font-weight: 200;
        text-decoration: none;
        color: grey;
      }
    }
  }

  .footerRights {
    margin-bottom: 0.5%;
  }

  .social-icon {
    display: inline-block;
    margin-bottom: 1%;
    width: 100%;
  }

  .social-icon {
    width: 100%;
  }

  .social-icon a {
    width: 42px;
    height: 42px;
    background: rgba(217, 217, 217, 0.1);
    display: inline-flex;
    border-radius: 50%;
    margin-right: 6px;
    align-items: center;
    justify-content: center;
    line-height: 1;
    border: 1.5px solid black;
  }

  .social-icon a::before {
    content: "";
    width: 40px;
    height: 40px;
    position: absolute;
    background-color: #D3D3D3;
    border-radius: 50%;
    transform: scale(0);
    transition: 0.3s ease-in-out;
  }

  .social-icon a:hover::before {
    transform: scale(1);
  }

  .social-icon a img {
    width: 40%;
    z-index: 1;
    transition: 0.3s ease-in-out;
  }

  .social-icon a:hover img {
    filter: brightness(0) saturate(100%) invert(0%) sepia(7%) saturate(98%) hue-rotate(346deg);
  }
}


/* CONTACT */
.AboutContact {
  padding-left: 10%;
  padding-right: 10%;

  .contact {
    display: grid;
    grid-template-columns: 1fr 3fr;
    padding-bottom: 3%;

    img {
      padding-right: 10%;
    }
  }

  h2 {
    margin-bottom: 3%;
    margin-top: 2%;
    display: flex;
    font-weight: 200;
  }

  p {
    font-size: 1.1em;
    margin-top: 5px;
    letter-spacing: 0.8px;
    line-height: 1.5em;
    width: 96%;
    text-align: justify;
    text-justify: inter-word;
  }

  .contact-form {
    width: 100%;
    margin-top: 20px;

    input[type='text'],
    input[type='email'] {
      width: 100%;
      max-width: 600px;
      height: 50px;
      font-size: 16px;
      padding: 0 20px;
      box-sizing: border-box;
      padding: 0;
      margin: 0;
      list-style: none;
      margin-bottom: 10px;
      overflow: hidden;
      display: block;
      position: relative;
      animation-fill-mode: forwards;
      border-color: transparent;
      border-bottom: 1px solid
    }

    textarea {
      width: 100%;
      max-width: 600px;
      margin-top: 10px;
      margin-bottom: 20px;
      height: 50px;
      font-size: 16px;
      min-height: 150px;
      display: block;
      box-sizing: border-box;
      border-color: transparent;
      border-bottom: 1px solid
    }

    .flat-button {
      color: white;
      font-size: large;
      background-color: black;
      font: 11px;
      letter-spacing: 3px;
      text-decoration: none;
      padding: 8px 10px;
      border: 2px solid black;
      width: auto;
      display: block;
    }
  }
}


.not-found {
  width: 100%;
  margin-top: 20px;

  .flat-button {
    color: white;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: large;
    background-color: black;
    font: 11px;
    letter-spacing: 3px;
    text-decoration: none;
    padding: 8px 10px;
    border: 2px solid black;
    width: auto;
  }
}

/*  LOGIN  */
.login {

  .login-container {
    max-width: 400px;
    margin: 2% auto;
    background-color: #fff;
    border-radius: 5px;
    padding: 1%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  h2 {
    text-align: center;
    margin-bottom: 6%;
    font-weight: lighter;
  }

  .form-group {
    margin-bottom: 6%;
  }

  label {
    display: block;
    font-weight: bold;
  }

  input[type="email"],
  input[type="password"] {
    width: 100%;
    padding: 2%;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  button {
    width: 30%;
    padding: 2%;
    background-color: black;
    color: #fff;
    border: none;
    cursor: pointer;
  }

  button:hover {
    background-color: #222222;
  }

  span {
    display: block;
    padding-top: 3%;
    font-size: 1.2em;
    color: red;
    margin-top: 1%;
  }
}

/*  UPLOAD IMAGE  */
.upload {

  .upload-container {
    max-width: 25em;
    margin: 2% auto;
    background-color: #fff;
    border-radius: 5px;
    padding: 1%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  h2 {
    text-align: center;
    margin-bottom: 6%;
    font-weight: lighter;
  }

  .form-group {
    margin-bottom: 6%;
  }

  textarea {
    height: 7em;
  }

  input[type="text"] {
    width: 100%;
    padding: 2%;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  button {
    width: 30%;
    padding: 2%;
    background-color: black;
    color: #fff;
    border: none;
    cursor: pointer;
    pointer-events: auto;
  }

  button:hover {
    background-color: #222222;
  }

  .dropZone {
    border: 2px dashed #ccc;
    border-radius: 20px;
    padding: 3%;
  }

  .dropZone:hover {
    border-color: black;
  }

  span {
    display: block;
    padding-top: 3%;
    font-size: 1.2em;
    color: red;
    margin-top: 1%;
  }

  .success {
    display: block;
    padding-top: 3%;
    font-size: 1.5em;
    color: green;
    margin-top: 1%;
  }
}


/* POP UP MODAL */

.sections {
  .modal {
    left: 0;
    overflow-y: hidden;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    /*  to hide first time   */
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    background-color: transparent;
    max-width: calc(100% - 7%);
    max-height: calc(100% - 7%);

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .close {
    position: fixed;
    width: 5%;
    height: 9%;
    background-color: transparent;
    color: #a9a9b5;
    border: none;
    cursor: pointer;
    top: 1%;
    right: 1%;
    font-size: 3em;
  }
}


/* APPLICATION */
.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;;AAEb;;AAEA,YAAY;;AAEZ;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;;AAGA;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;AACF;;AAEA,WAAW;;AAEX;EACE,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;;EAElB,gCAAgC;;EAEhC;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,sCAAsC;;IAEtC;MACE,gBAAgB;MAChB,iBAAiB;MACjB,UAAU;IACZ;;IAEA;MACE,gCAAgC;IAClC;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,gBAAgB;MAChB,qBAAqB;MACrB,YAAY;IACd;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE;IACF;;EAEF;;EAEA;IACE;MACE;QACE,eAAe;MACjB;IACF;EACF;;EAEA;IACE;MACE,aAAa;MACb,8BAA8B;;MAE9B;QACE,eAAe;MACjB;IACF;EACF;;EAEA;IACE;MACE,aAAa;MACb,0BAA0B;;MAE1B;QACE,eAAe;MACjB;IACF;EACF;AACF;;;;;;AAMA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;;EAEhC;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,aAAa;;IAEb;MACE,gBAAgB;MAChB,iBAAiB;MACjB,UAAU;MACV,kBAAkB;IACpB;;IAEA;MACE,gCAAgC;IAClC;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,gBAAgB;MAChB,qBAAqB;MACrB,YAAY;IACd;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;;IAEpB;;IAEA;MACE,uBAAuB;MACvB,kBAAkB;;IAEpB;;EAEF;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,aAAa;;IAEb;MACE,gBAAgB;MAChB,iBAAiB;MACjB,UAAU;MACV,kBAAkB;;IAEpB;;IAEA;MACE,gCAAgC;IAClC;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,gBAAgB;MAChB,qBAAqB;MACrB,YAAY;IACd;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;;MAElB;QACE,gBAAgB;MAClB;;MAEA;QACE;MACF;IACF;;;EAGF;;EAEA;IACE;MACE;QACE,eAAe;MACjB;IACF;EACF;;EAEA;IACE;MACE,aAAa;;MAEb;QACE,eAAe;MACjB;IACF;EACF;;EAEA;IACE;MACE,aAAa;;MAEb;QACE,eAAe;MACjB;IACF;EACF;AACF;;;;;;;;;;;;;;AAcA,aAAa;;AAEb;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;;;;;;AAOA,YAAY;AACZ;;EAEE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE;EACF;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,kCAAkC;IACpC;;IAEA;MACE,aAAa;MACb,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,YAAY;MACZ,aAAa;MACb,sCAAsC;;MAEtC;QACE;UACE,gCAAgC;UAChC,gBAAgB;UAChB,gBAAgB;UAChB,qBAAqB;UACrB,WAAW;QACb;;QAEA;UACE,sBAAsB;UACtB,gBAAgB;QAClB;;QAEA;UACE,gBAAgB;UAChB,YAAY;QACd;MACF;;IAEF;;EAEF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,YAAY;MACZ,aAAa;MACb,sCAAsC;;MAEtC;QACE;UACE,gCAAgC;UAChC,gBAAgB;UAChB,gBAAgB;UAChB,qBAAqB;UACrB,WAAW;QACb;;QAEA;UACE,sBAAsB;UACtB,gBAAgB;QAClB;;QAEA;UACE,gBAAgB;UAChB,YAAY;QACd;MACF;;IAEF;;IAEA;MACE,aAAa;MACb,8BAA8B;;MAE9B;QACE,aAAa;QACb,8BAA8B;MAChC;IACF;;IAEA;MACE,aAAa;MACb,kCAAkC;IACpC;;IAEA;MACE;QACE,aAAa;QACb,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,YAAY;MACZ,aAAa;MACb,sCAAsC;;MAEtC;QACE;UACE,gCAAgC;UAChC,gBAAgB;UAChB,gBAAgB;UAChB,qBAAqB;UACrB,WAAW;QACb;;QAEA;UACE,sBAAsB;UACtB,gBAAgB;QAClB;;QAEA;UACE,gBAAgB;UAChB,YAAY;QACd;MACF;IACF;;IAEA;MACE,aAAa;MACb,kCAAkC;IACpC;;IAEA;MACE;QACE,aAAa;QACb,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,YAAY;MACZ,aAAa;MACb,sCAAsC;;MAEtC;QACE;UACE,gCAAgC;UAChC,iBAAiB;UACjB,gBAAgB;UAChB,qBAAqB;UACrB,WAAW;QACb;;QAEA;UACE,sBAAsB;UACtB,gBAAgB;QAClB;;QAEA;UACE,gBAAgB;UAChB,YAAY;QACd;MACF;IACF;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,WAAW;;IAEb;;IAEA;MACE,qBAAqB;MACrB,YAAY;IACd;;IAEA;MACE,6BAA6B;MAC7B,eAAe;MACf,kBAAkB;IACpB;EACF;;;;EAIA;IACE,iBAAiB;IACjB,kBAAkB;;;EAGpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,YAAY;MACZ,aAAa;MACb,sCAAsC;;MAEtC;QACE;UACE,gCAAgC;UAChC,gBAAgB;UAChB,gBAAgB;UAChB,qBAAqB;UACrB,WAAW;QACb;;QAEA;UACE,sBAAsB;UACtB,gBAAgB;QAClB;;QAEA;UACE,gBAAgB;UAChB,YAAY;QACd;MACF;IACF;;IAEA;MACE,aAAa;MACb,kCAAkC;IACpC;;IAEA;MACE;QACE,aAAa;QACb,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,aAAa;MACb,8BAA8B;IAChC;;EAEF;AACF;;;AAGA,WAAW;;AAEX;EACE,WAAW;;EAEX;IACE,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,sCAAsC;;IAEtC;MACE;QACE,gCAAgC;QAChC,gBAAgB;QAChB,gBAAgB;QAChB,qBAAqB;QACrB,WAAW;MACb;IACF;EACF;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,0FAA0F;EAC5F;AACF;;;AAGA,YAAY;AACZ;EACE,iBAAiB;EACjB,kBAAkB;;EAElB;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;;IAElB;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,gBAAgB;;IAEhB;;MAEE,WAAW;MACX,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,eAAe;MACf,sBAAsB;MACtB,UAAU;MACV,SAAS;MACT,gBAAgB;MAChB,mBAAmB;MACnB,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,6BAA6B;MAC7B,yBAAyB;MACzB;IACF;;IAEA;MACE,WAAW;MACX,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB;MACnB,YAAY;MACZ,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,sBAAsB;MACtB,yBAAyB;MACzB;IACF;;IAEA;MACE,YAAY;MACZ,gBAAgB;MAChB,uBAAuB;MACvB,UAAU;MACV,mBAAmB;MACnB,qBAAqB;MACrB,iBAAiB;MACjB,uBAAuB;MACvB,WAAW;MACX,cAAc;IAChB;EACF;AACF;;;AAGA;EACE,WAAW;EACX,gBAAgB;;EAEhB;IACE,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;IACV,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA,YAAY;AACZ;;EAEE;IACE,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,cAAc;EAChB;AACF;;AAEA,mBAAmB;AACnB;;EAEE;IACE,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;EAChB;AACF;;;AAGA,iBAAiB;;AAEjB;EACE;IACE,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;;IAE3B;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;IACrB;EACF;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,eAAe;IACf,OAAO;IACP,SAAS;IACT,cAAc;EAChB;AACF;;;AAGA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');\r\n\r\n* {\r\n  font-family: 'Raleway';\r\n  overflow-x: hidden;\r\n  width: 100%;\r\n\r\n}\r\n\r\n/* NAV BAR */\r\n\r\n.navbar-header h1 {\r\n  font-weight: 300;\r\n  color: black;\r\n  letter-spacing: 3px;\r\n  display: flex;\r\n}\r\n\r\n.navbar-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  overflow-y: hidden;\r\n}\r\n\r\nnav.navbar a.navbar-brand {\r\n  width: 45%;\r\n}\r\n\r\n.navbar-links {\r\n  align-items: center !important;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.navbar-links .navbar-link {\r\n  color: #808080;\r\n  align-items: center !important;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  width: 33%;\r\n  text-align: center;\r\n}\r\n\r\n.navbar-links .navbar-link:hover {\r\n  color: rgb(70, 69, 69);\r\n  font-weight: 550;\r\n}\r\n\r\n.navbar-links .navbar-nav {\r\n  align-items: center !important;\r\n  display: inline;\r\n  vertical-align: middle;\r\n  padding-right: 10%;\r\n}\r\n\r\n.Nav-bar-general {\r\n  align-items: center;\r\n  line-height: 3.5;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  color: #808080;\r\n  padding-left: 3.5%;\r\n}\r\n\r\n.Nav-bar-general .logo {\r\n  height: 15vmin;\r\n  width: 15vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n\r\n@media screen and (max-width: 1165px) {\r\n  .navbar-header h1 {\r\n    display: inline;\r\n    padding-top: 0%;\r\n  }\r\n\r\n  .navbar-links {\r\n    display: inline;\r\n    padding-top: 0%;\r\n  }\r\n\r\n  .navbar-links .navbar-link {\r\n    width: 33%;\r\n    padding-top: 0%;\r\n  }\r\n\r\n  .Nav-bar-general {\r\n    display: inline;\r\n    padding-top: 0%;\r\n  }\r\n\r\n  nav.navbar a.navbar-brand {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .navbar-links .navbar-link {\r\n    display: block;\r\n    flex-direction: column;\r\n    vertical-align: middle;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    flex: none;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* BANNER */\r\n\r\nhr.solid {\r\n  border-top: 5px solid #808080;\r\n  padding: 0;\r\n  padding-bottom: 1%;\r\n  overflow-y: hidden;\r\n}\r\n\r\n.banner {\r\n  align-items: center;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  overflow-y: hidden;\r\n\r\n  text-decoration: none !important;\r\n\r\n  .section-container {\r\n    overflow-y: hidden;\r\n    padding: 0.8%;\r\n    position: relative;\r\n    text-align: center;\r\n    color: white;\r\n    padding-left: 8%;\r\n    padding-right: 8%;\r\n    text-decoration: none;\r\n    color: black;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr;\r\n\r\n    img {\r\n      padding-left: 3%;\r\n      padding-right: 3%;\r\n      z-index: 0;\r\n    }\r\n\r\n    a {\r\n      text-decoration: none !important;\r\n    }\r\n\r\n    p {\r\n      margin-top: 2%;\r\n      font-size: 1.5em;\r\n      font-weight: 200;\r\n      text-decoration: none;\r\n      color: black;\r\n    }\r\n\r\n    .individualSection:hover p {\r\n      font-weight: 300;\r\n    }\r\n\r\n    .individualSection:hover img {\r\n      filter: brightness(80%)\r\n    }\r\n\r\n  }\r\n\r\n  @media screen and (max-width: 1500px) {\r\n    .section-container {\r\n      p {\r\n        font-size: 15px;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 1050px) {\r\n    .section-container {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n\r\n      p {\r\n        font-size: 15px;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 480px) {\r\n    .section-container {\r\n      display: grid;\r\n      grid-template-columns: 1fr;\r\n\r\n      p {\r\n        font-size: 15px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.testBanner {\r\n  align-items: center;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  overflow-y: hidden;\r\n  text-decoration: none !important;\r\n\r\n  .section-container {\r\n    overflow-y: hidden;\r\n    padding: 0.8%;\r\n    position: relative;\r\n    text-align: center;\r\n    color: white;\r\n    padding-left: 8%;\r\n    padding-right: 8%;\r\n    text-decoration: none;\r\n    color: black;\r\n    display: grid;\r\n\r\n    img {\r\n      padding-left: 3%;\r\n      padding-right: 3%;\r\n      z-index: 0;\r\n      overflow-y: hidden;\r\n    }\r\n\r\n    a {\r\n      text-decoration: none !important;\r\n    }\r\n\r\n    p {\r\n      margin-top: 2%;\r\n      font-size: 1.5em;\r\n      font-weight: 200;\r\n      text-decoration: none;\r\n      color: black;\r\n    }\r\n\r\n    .individualSection:hover p {\r\n      font-weight: 300;\r\n      overflow-y: hidden;\r\n\r\n    }\r\n\r\n    .individualSection:hover img {\r\n      filter: brightness(80%);\r\n      overflow-y: hidden;\r\n\r\n    }\r\n\r\n  }\r\n\r\n  .section-carrusel {\r\n    overflow-y: hidden;\r\n    padding: 0.8%;\r\n    position: relative;\r\n    text-align: center;\r\n    color: white;\r\n    padding-left: 8%;\r\n    padding-right: 8%;\r\n    text-decoration: none;\r\n    color: black;\r\n    display: grid;\r\n\r\n    img {\r\n      padding-left: 3%;\r\n      padding-right: 3%;\r\n      z-index: 0;\r\n      overflow-y: hidden;\r\n\r\n    }\r\n\r\n    a {\r\n      text-decoration: none !important;\r\n    }\r\n\r\n    p {\r\n      margin-top: 2%;\r\n      font-size: 1.5em;\r\n      font-weight: 200;\r\n      text-decoration: none;\r\n      color: black;\r\n    }\r\n\r\n    .individualSection {\r\n      overflow: hidden;\r\n      overflow-y: hidden;\r\n      position: relative;\r\n      z-index: 9;\r\n    }\r\n\r\n    .individualSection:hover {\r\n      overflow: hidden;\r\n      overflow-y: hidden;\r\n\r\n      p {\r\n        font-weight: 300;\r\n      }\r\n\r\n      img {\r\n        filter: brightness(80%)\r\n      }\r\n    }\r\n\r\n\r\n  }\r\n\r\n  @media screen and (max-width: 1500px) {\r\n    .section-carrusel {\r\n      p {\r\n        font-size: 15px;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 1050px) {\r\n    .section-carrusel {\r\n      display: grid;\r\n\r\n      p {\r\n        font-size: 15px;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 480px) {\r\n    .section-carrusel {\r\n      display: grid;\r\n\r\n      p {\r\n        font-size: 15px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* CAROUSEL */\r\n\r\n.react-multi-carousel-list {\r\n  width: auto;\r\n}\r\n\r\n.react-multi-carousel-track {\r\n  width: auto;\r\n}\r\n\r\n.react-multiple-carousel__arrow {\r\n  width: auto;\r\n  margin: -4%;\r\n  overflow: visible;\r\n  z-index: 10000000000 !important;\r\n  position: absolute;\r\n}\r\n\r\n.react-multi-carousel {\r\n  position: relative;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* SECTIONS*/\r\n.sections {\r\n\r\n  h2 {\r\n    padding-top: 1%;\r\n    padding-bottom: 2%;\r\n    font-weight: 200;\r\n  }\r\n\r\n  img {\r\n    padding: 10px 10px 10px 10px;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .clickableImg:hover {\r\n    filter: brightness(85%)\r\n  }\r\n\r\n  p {\r\n    font-size: 1.1em;\r\n    margin-top: 1%;\r\n    margin-bottom: 1%;\r\n    letter-spacing: 0.8px;\r\n    line-height: 1.5em;\r\n    width: 96%;\r\n    text-align: justify;\r\n    text-justify: inter-word;\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n  }\r\n\r\n  .genericSection {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .secondRow {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr;\r\n    }\r\n\r\n    .section-nav {\r\n      padding: 0.8%;\r\n      padding-top: 2%;\r\n      position: relative;\r\n      text-align: center;\r\n      text-decoration: none;\r\n      color: black;\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr 1fr;\r\n\r\n      p {\r\n        a {\r\n          text-decoration: none !important;\r\n          font-size: 1.5em;\r\n          font-weight: 200;\r\n          text-decoration: none;\r\n          color: grey;\r\n        }\r\n\r\n        a:hover {\r\n          color: rgb(70, 69, 69);\r\n          font-weight: 400;\r\n        }\r\n\r\n        .ilu {\r\n          font-weight: 600;\r\n          color: black;\r\n        }\r\n      }\r\n\r\n    }\r\n\r\n  }\r\n\r\n  .illustration {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .section-nav {\r\n      padding: 0.8%;\r\n      padding-top: 2%;\r\n      position: relative;\r\n      text-align: center;\r\n      text-decoration: none;\r\n      color: black;\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr 1fr;\r\n\r\n      p {\r\n        a {\r\n          text-decoration: none !important;\r\n          font-size: 1.5em;\r\n          font-weight: 200;\r\n          text-decoration: none;\r\n          color: grey;\r\n        }\r\n\r\n        a:hover {\r\n          color: rgb(70, 69, 69);\r\n          font-weight: 400;\r\n        }\r\n\r\n        .ilu {\r\n          font-weight: 600;\r\n          color: black;\r\n        }\r\n      }\r\n\r\n    }\r\n\r\n    .firstRow {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n\r\n      .fourImages {\r\n        display: grid;\r\n        grid-template-columns: 1fr 1fr;\r\n      }\r\n    }\r\n\r\n    .secondRow {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr;\r\n    }\r\n\r\n    @media screen and (max-width: 480px) {\r\n      .secondRow {\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n      }\r\n    }\r\n  }\r\n\r\n  .sketchbook {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .section-nav {\r\n      padding: 0.8%;\r\n      padding-top: 2%;\r\n      position: relative;\r\n      text-align: center;\r\n      text-decoration: none;\r\n      color: black;\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr 1fr;\r\n\r\n      p {\r\n        a {\r\n          text-decoration: none !important;\r\n          font-size: 1.5em;\r\n          font-weight: 200;\r\n          text-decoration: none;\r\n          color: grey;\r\n        }\r\n\r\n        a:hover {\r\n          color: rgb(70, 69, 69);\r\n          font-weight: 400;\r\n        }\r\n\r\n        .ske {\r\n          font-weight: 600;\r\n          color: black;\r\n        }\r\n      }\r\n    }\r\n\r\n    .threeRows {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr;\r\n    }\r\n\r\n    @media screen and (max-width: 480px) {\r\n      .threeRows {\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n      }\r\n    }\r\n  }\r\n\r\n  .CharacterDesign {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .section-nav {\r\n      padding: 0.8%;\r\n      padding-top: 2%;\r\n      position: relative;\r\n      text-align: center;\r\n      text-decoration: none;\r\n      color: black;\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr 1fr;\r\n\r\n      p {\r\n        a {\r\n          text-decoration: none !important;\r\n          font-size: 1.45em;\r\n          font-weight: 200;\r\n          text-decoration: none;\r\n          color: grey;\r\n        }\r\n\r\n        a:hover {\r\n          color: rgb(70, 69, 69);\r\n          font-weight: 400;\r\n        }\r\n\r\n        .cd {\r\n          font-weight: 600;\r\n          color: black;\r\n        }\r\n      }\r\n    }\r\n\r\n    .chaD {\r\n      font-weight: 350;\r\n    }\r\n\r\n    .chaD:hover {\r\n      font-weight: 400;\r\n    }\r\n\r\n    .creD:hover {\r\n      font-weight: 400;\r\n    }\r\n\r\n    .creD2 {\r\n      font-weight: 350;\r\n    }\r\n\r\n    .chaD2:hover {\r\n      font-weight: 400;\r\n    }\r\n\r\n    .creD2:hover {\r\n      font-weight: 400;\r\n    }\r\n\r\n    .secondTitle {\r\n      padding: 4%;\r\n\r\n    }\r\n\r\n    a {\r\n      text-decoration: none;\r\n      color: black;\r\n    }\r\n\r\n    hr.solid {\r\n      border-top: 5px solid #808080;\r\n      padding-top: 2%;\r\n      padding-bottom: 2%;\r\n    }\r\n  }\r\n\r\n\r\n\r\n  .CreatureDesign {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n\r\n  }\r\n\r\n  .PropDesign {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .section-nav {\r\n      padding: 0.8%;\r\n      position: relative;\r\n      text-align: center;\r\n      text-decoration: none;\r\n      color: black;\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr 1fr;\r\n\r\n      p {\r\n        a {\r\n          text-decoration: none !important;\r\n          font-size: 1.5em;\r\n          font-weight: 200;\r\n          text-decoration: none;\r\n          color: grey;\r\n        }\r\n\r\n        a:hover {\r\n          color: rgb(70, 69, 69);\r\n          font-weight: 400;\r\n        }\r\n\r\n        .pd {\r\n          font-weight: 600;\r\n          color: black;\r\n        }\r\n      }\r\n    }\r\n\r\n    .threeRows {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 1fr;\r\n    }\r\n\r\n    @media screen and (max-width: 480px) {\r\n      .threeRows {\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n      }\r\n    }\r\n  }\r\n\r\n  .NDA {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    .twoImages {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n  }\r\n}\r\n\r\n\r\n/* FOOTER */\r\n\r\n.footer {\r\n  width: 100%;\r\n\r\n  .section-nav {\r\n    padding: 0.8%;\r\n    position: relative;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    color: black;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr;\r\n\r\n    p {\r\n      a {\r\n        text-decoration: none !important;\r\n        font-size: 1.5em;\r\n        font-weight: 200;\r\n        text-decoration: none;\r\n        color: grey;\r\n      }\r\n    }\r\n  }\r\n\r\n  .footerRights {\r\n    margin-bottom: 0.5%;\r\n  }\r\n\r\n  .social-icon {\r\n    display: inline-block;\r\n    margin-bottom: 1%;\r\n    width: 100%;\r\n  }\r\n\r\n  .social-icon {\r\n    width: 100%;\r\n  }\r\n\r\n  .social-icon a {\r\n    width: 42px;\r\n    height: 42px;\r\n    background: rgba(217, 217, 217, 0.1);\r\n    display: inline-flex;\r\n    border-radius: 50%;\r\n    margin-right: 6px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    line-height: 1;\r\n    border: 1.5px solid black;\r\n  }\r\n\r\n  .social-icon a::before {\r\n    content: \"\";\r\n    width: 40px;\r\n    height: 40px;\r\n    position: absolute;\r\n    background-color: #D3D3D3;\r\n    border-radius: 50%;\r\n    transform: scale(0);\r\n    transition: 0.3s ease-in-out;\r\n  }\r\n\r\n  .social-icon a:hover::before {\r\n    transform: scale(1);\r\n  }\r\n\r\n  .social-icon a img {\r\n    width: 40%;\r\n    z-index: 1;\r\n    transition: 0.3s ease-in-out;\r\n  }\r\n\r\n  .social-icon a:hover img {\r\n    filter: brightness(0) saturate(100%) invert(0%) sepia(7%) saturate(98%) hue-rotate(346deg);\r\n  }\r\n}\r\n\r\n\r\n/* CONTACT */\r\n.AboutContact {\r\n  padding-left: 10%;\r\n  padding-right: 10%;\r\n\r\n  .contact {\r\n    display: grid;\r\n    grid-template-columns: 1fr 3fr;\r\n    padding-bottom: 3%;\r\n\r\n    img {\r\n      padding-right: 10%;\r\n    }\r\n  }\r\n\r\n  h2 {\r\n    margin-bottom: 3%;\r\n    margin-top: 2%;\r\n    display: flex;\r\n    font-weight: 200;\r\n  }\r\n\r\n  p {\r\n    font-size: 1.1em;\r\n    margin-top: 5px;\r\n    letter-spacing: 0.8px;\r\n    line-height: 1.5em;\r\n    width: 96%;\r\n    text-align: justify;\r\n    text-justify: inter-word;\r\n  }\r\n\r\n  .contact-form {\r\n    width: 100%;\r\n    margin-top: 20px;\r\n\r\n    input[type='text'],\r\n    input[type='email'] {\r\n      width: 100%;\r\n      max-width: 600px;\r\n      height: 50px;\r\n      font-size: 16px;\r\n      padding: 0 20px;\r\n      box-sizing: border-box;\r\n      padding: 0;\r\n      margin: 0;\r\n      list-style: none;\r\n      margin-bottom: 10px;\r\n      overflow: hidden;\r\n      display: block;\r\n      position: relative;\r\n      animation-fill-mode: forwards;\r\n      border-color: transparent;\r\n      border-bottom: 1px solid\r\n    }\r\n\r\n    textarea {\r\n      width: 100%;\r\n      max-width: 600px;\r\n      margin-top: 10px;\r\n      margin-bottom: 20px;\r\n      height: 50px;\r\n      font-size: 16px;\r\n      min-height: 150px;\r\n      display: block;\r\n      box-sizing: border-box;\r\n      border-color: transparent;\r\n      border-bottom: 1px solid\r\n    }\r\n\r\n    .flat-button {\r\n      color: white;\r\n      font-size: large;\r\n      background-color: black;\r\n      font: 11px;\r\n      letter-spacing: 3px;\r\n      text-decoration: none;\r\n      padding: 8px 10px;\r\n      border: 2px solid black;\r\n      width: auto;\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.not-found {\r\n  width: 100%;\r\n  margin-top: 20px;\r\n\r\n  .flat-button {\r\n    color: white;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    font-size: large;\r\n    background-color: black;\r\n    font: 11px;\r\n    letter-spacing: 3px;\r\n    text-decoration: none;\r\n    padding: 8px 10px;\r\n    border: 2px solid black;\r\n    width: auto;\r\n  }\r\n}\r\n\r\n/*  LOGIN  */\r\n.login {\r\n\r\n  .login-container {\r\n    max-width: 400px;\r\n    margin: 2% auto;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    padding: 1%;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  h2 {\r\n    text-align: center;\r\n    margin-bottom: 6%;\r\n    font-weight: lighter;\r\n  }\r\n\r\n  .form-group {\r\n    margin-bottom: 6%;\r\n  }\r\n\r\n  label {\r\n    display: block;\r\n    font-weight: bold;\r\n  }\r\n\r\n  input[type=\"email\"],\r\n  input[type=\"password\"] {\r\n    width: 100%;\r\n    padding: 2%;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  button {\r\n    width: 30%;\r\n    padding: 2%;\r\n    background-color: black;\r\n    color: #fff;\r\n    border: none;\r\n    cursor: pointer;\r\n  }\r\n\r\n  button:hover {\r\n    background-color: #222222;\r\n  }\r\n\r\n  span {\r\n    display: block;\r\n    padding-top: 3%;\r\n    font-size: 1.2em;\r\n    color: red;\r\n    margin-top: 1%;\r\n  }\r\n}\r\n\r\n/*  UPLOAD IMAGE  */\r\n.upload {\r\n\r\n  .upload-container {\r\n    max-width: 25em;\r\n    margin: 2% auto;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    padding: 1%;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  h2 {\r\n    text-align: center;\r\n    margin-bottom: 6%;\r\n    font-weight: lighter;\r\n  }\r\n\r\n  .form-group {\r\n    margin-bottom: 6%;\r\n  }\r\n\r\n  textarea {\r\n    height: 7em;\r\n  }\r\n\r\n  input[type=\"text\"] {\r\n    width: 100%;\r\n    padding: 2%;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  button {\r\n    width: 30%;\r\n    padding: 2%;\r\n    background-color: black;\r\n    color: #fff;\r\n    border: none;\r\n    cursor: pointer;\r\n    pointer-events: auto;\r\n  }\r\n\r\n  button:hover {\r\n    background-color: #222222;\r\n  }\r\n\r\n  .dropZone {\r\n    border: 2px dashed #ccc;\r\n    border-radius: 20px;\r\n    padding: 3%;\r\n  }\r\n\r\n  .dropZone:hover {\r\n    border-color: black;\r\n  }\r\n\r\n  span {\r\n    display: block;\r\n    padding-top: 3%;\r\n    font-size: 1.2em;\r\n    color: red;\r\n    margin-top: 1%;\r\n  }\r\n\r\n  .success {\r\n    display: block;\r\n    padding-top: 3%;\r\n    font-size: 1.5em;\r\n    color: green;\r\n    margin-top: 1%;\r\n  }\r\n}\r\n\r\n\r\n/* POP UP MODAL */\r\n\r\n.sections {\r\n  .modal {\r\n    left: 0;\r\n    overflow-y: hidden;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.9);\r\n    display: flex;\r\n    /*  to hide first time   */\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .modal-content {\r\n    background-color: transparent;\r\n    max-width: calc(100% - 7%);\r\n    max-height: calc(100% - 7%);\r\n\r\n    img {\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: contain;\r\n    }\r\n  }\r\n\r\n  .close {\r\n    position: fixed;\r\n    width: 5%;\r\n    height: 9%;\r\n    background-color: transparent;\r\n    color: #a9a9b5;\r\n    border: none;\r\n    cursor: pointer;\r\n    top: 1%;\r\n    right: 1%;\r\n    font-size: 3em;\r\n  }\r\n}\r\n\r\n\r\n/* APPLICATION */\r\n.App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
